export default __webpack_public_path__ + "message.c4a26b2669272841d8cd.svg";